module.exports = __webpack_public_path__ + "img/teak_brown_ba_list.00f43f29.jpg";